import PropTypes from "prop-types";
import React, { Component } from "react";

import Avatar from "components/avatar";
import { Dropdown } from "components/Dropdown/Dropdown";
import Form from "components/react-validation/components/form";
import Input from "components/react-validation/components/input";
import Submit from "components/react-validation/components/submit";
import { Col, Row } from "react-bootstrap";
import { AppSettings } from "../../constants";
import * as UserActionType from "../constants";
import "../invite-user.scss";

const roleOptions =
  (AppSettings.ROLES &&
    AppSettings.ROLES.map((key) => {
      // if(AppSettings.clientTypeValue === 'System'){
      //   return {
      //     text: AppSettings.LIST_ROLES.find(t => t.key === key.key).value,
      //     value: key
      //   };
      // }else{
      return {
        text: AppSettings.LIST_ROLES.find((t) => t.key === key).value,
        value: key,
      };
      // }
    })) ||
  [];

export class InviteSystemUser extends Component {
  static propTypes = {
    isHidden: PropTypes.bool,
    onSave: PropTypes.func,
    onBack: PropTypes.func,
    modalName: PropTypes.string,
    errorMsg: PropTypes.array,
    userProfile: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedRole: roleOptions[0],
    };
  }

  onSelectRole = (e) => {
    this.setState({ selectedRole: e.value });
  };

  // componentWillReceiveProps(nextProps) {
  //   var roleName = nextProps.userProfile.roleName;
  //   nextProps.userProfile.roleName = (Unit.isEmpty(roleName) ? AppSettings.DEFAULT_ROLES_SYSTEM : roleName);
  // }

  onSubmit(e) {
    let data = this.form.getValues();
    data["roleName"] = this.state.selectedRole.value;
    this.props.onSave(e, data, UserActionType.INVITE_USER_IN_SYSTEM_ASYNC);
    e.preventDefault();
  }

  render() {
    return (
      !this.props.isHidden && (
        <div className={this.props.isHidden ? "cls-hidden" : ""}>
          <Form
            ref={(c) => {
              this.form = c;
            }}
            onSubmit={this.onSubmit.bind(this)}
          >
            <div className="box-form-body">
              <Row>
                <Col md={6} sm={6}>
                  <p className="description">
                    The email address{" "}
                    <span className="cls-bold">
                      {this.props.userProfile.email}
                    </span>{" "}
                    already has an account on SiteOne Services:
                  </p>
                  <div className="form-group">
                    <div className="cls-existing-user">
                      <Avatar src={null} size={80} />
                      <h4 className="cls-bold">
                        {this.props.userProfile.fullName}
                      </h4>
                      <h5>{this.props.userProfile.email}</h5>
                    </div>
                  </div>

                  <div className="form-group" style={{ marginTop: "30px" }}>
                    <p className="cls-description">
                      If you want to invite{" "}
                      <span className="cls-bold">
                        {this.props.userProfile.fullName}
                      </span>{" "}
                      to{" "}
                      {window.profile.clientType === 1
                        ? AppSettings.COMPANY_NAME
                        : "SiteOne Services"}
                      , select one role to assign to
                      <span className="cls-bold">
                        {" "}
                        {this.props.userProfile.fullName}
                      </span>
                    </p>
                  </div>

                  <div className="form-group role-select col-md-6">
                    <Input
                      type="hidden"
                      name="redirectUrl"
                      value={AppSettings.REDIRECT_URL_INVITE}
                    />
                    <Input
                      type="hidden"
                      name="userId"
                      value={this.props.userProfile.userId}
                    />
                    <Input
                      type="hidden"
                      name="firstName"
                      value={this.props.userProfile.firstName}
                    />
                    <Input
                      type="hidden"
                      name="lastName"
                      value={this.props.userProfile.lastName}
                    />
                    <Input
                      type="hidden"
                      name="email"
                      value={this.props.userProfile.email}
                    />
                    <Dropdown
                      onChange={this.onSelectRole}
                      className="filestring-dropdown filter-dropdown"
                      options={roleOptions}
                      optionLabel="text"
                      value={this.state.selectedRole}
                      name="role"
                      placeholder="-- Please select"
                      style={{ width: "100%" }}
                    />
                  </div>

                  <div className="form-group text-left">
                    <a
                      className="btn btn-primary margin-right-5 btn-siteone-default"
                      onClick={(e) => {
                        this.props.onBack(e);
                      }}
                    >
                      <i className="glyphicon glyphicon-menu-left" /> Back
                    </a>
                    <Submit className="btn btn-primary btn-siteone">
                      Invite
                    </Submit>
                  </div>
                </Col>
              </Row>
            </div>
          </Form>
        </div>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/User/Components/invite-system-user.js